import { Selection } from '@interfaces/selection';
import { getCall } from '@services/rest-service';

// Retrieves all the selections from cosmos
export const getSelections = (): Promise<Selection[]> => {
  return getCall<Selection[]>('selections');
};